// Demo mode helper - used by all services to handle demo user queries

export const isDemoMode = () => localStorage.getItem('demo_mode') === 'true';

export const getDemoOrgId = () => localStorage.getItem('demo_org_id') || null;

// ---------------------------------------------------------------------------
// In-memory auth store
// AuthContext writes the org_id here whenever the session or organization
// changes (including after every token refresh). Services read from here
// instead of re-querying user_profiles on every fetch, which was the root
// cause of data loading failures after ~60 seconds (token refresh window).
// ---------------------------------------------------------------------------
let _orgId = null;

export const setAuthOrgId = (orgId) => {
  _orgId = orgId || null;
};

export const getAuthOrgId = () => _orgId;
